<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <h1 class="nombre-protagonista1">
      <span class="nombre-kenia">Kenia</span><br>
      <span class="apellido-playfair">Monje</span>
    </h1>

    <!-- FLORES Y RAMAS DECORATIVAS -->
    <div v-for="i in 6" :key="'group-'+i" :class="'flor-group flor-' + i">
      <img src="@/assets/fll.png" class="flor-img" alt="" />
      <!-- RAMA QUE NACE DE LA FLOR -->
      <img src="@/assets/rama.png" class="rama-img" alt="" />
    </div>

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/princ.png" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- TEXTO PRINCIPAL -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        Con la bendición de Dios <br />
        y de mis padres
      </p>

      <h1>
        <span class="inicial-g">G</span><span class="nombre-normal">audencio Solis</span>
      </h1>
      <img
        src="@/assets/ampersand.png"
        class="ampersand ampersand-padres"
        alt="&"
      />
      <h1 class="nombre-protagonista">   Fany Monje  &nbsp; </h1>

      <div class="separador-elegante" aria-hidden="true"></div>

      <p class="parrafo-presentacion">
        Hay momentos en la vida que permanecen para siempre en el corazón,
y hoy guiada por el amor de Dios y rodeada de las personas que más amo, celebro el regalo maravilloso de cumplir 
      </p>
      <h1 class="nombre-protagonista2">   15 Años  &nbsp; </h1>

      <div class="versiculo-container">
        <p class="versiculo-texto">
        </p>

        <p class="versiculo-referencia">
        </p>
      </div>
    </section>

    <!-- 🔹 INDICADOR FIJO SIEMPRE VISIBLE DESDE EL INICIO EN LA ESQUINA INFERIOR IZQUIERDA -->
    <div class="scroll-indicator">
      <!-- Icono FontAwesome Hand Pointer Down -->
      <svg class="hand-icon" viewBox="0 0 448 512" fill="currentColor">
        <path d="M448 240c0-17.7-14.3-32-32-32h-12.7c-5.4 0-10.7 1.4-15.5 4.1L320 250.9V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v128h-16V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v192h-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v220.9l-30.1-30.1c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c21.4 21.4 48 35.8 77.2 41.3C210.1 508 231 512 252.1 512H288c88.4 0 160-71.6 160-160v-112z"/>
      </svg>
      <span class="scroll-text">Desliza abajo</span>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',

  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) =>
        Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = $('.flor-img')
      const ramas = $('.rama-img')

      // ✨ ELEMENTOS
      const keniaText = document.querySelector('.nombre-kenia')
      const monjeText = document.querySelector('.apellido-playfair')
      const quince = document.querySelector('.nombre-protagonista2')
      const versiculo = document.querySelector('.versiculo-container')
      const scrollIndicator = document.querySelector('.scroll-indicator')

      // 🔹 ANIMACIÓN DE LA MANITA
      if (scrollIndicator) {
        gsap.to(scrollIndicator, {
          y: 8,
          duration: 1,
          repeat: -1,
          yoyo: true,
          ease: 'power1.inOut'
        })
      }

      // ✨ TEXTO NORMAL
      const texto = [
        '.frase-bendicion',
        '.texto-xv .nombre-protagonista',
        '.separador-elegante',
        '.padrinos-label',
        '.padrino-nombre',
        '.parrafo-presentacion',
        '.ampersand'
      ].flatMap($)

      // ✨ ESTADOS INICIALES FINOS Y MEJORADOS
      gsap.set([...foto, ...texto], {
        autoAlpha: 0,
        y: 20
      })

      // Estado inicial separado para Kenia y Monje
      if (keniaText) {
        gsap.set(keniaText, {
          display: 'inline-block',
          autoAlpha: 0,
          scale: 0.8,
          y: -30,
          rotationX: -20,
          filter: 'blur(12px)'
        })
      }

      if (monjeText) {
        gsap.set(monjeText, {
          display: 'inline-block',
          autoAlpha: 0,
          scale: 0.8,
          y: 30,
          filter: 'blur(12px)'
        })
      }

      gsap.set(quince, {
        autoAlpha: 0,
        scale: 1.4,
        letterSpacing: '25px',
        filter: 'blur(18px)'
      })

      gsap.set(versiculo, {
        autoAlpha: 0,
        y: 30,
        filter: 'blur(10px)'
      })

      gsap.set(flores, {
        autoAlpha: 0,
        scale: 0.85,
        filter: 'brightness(1.3)'
      })

      gsap.set(ramas, {
        autoAlpha: 0,
        scale: 0,
        transformOrigin: "center center"
      })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({
            defaults: {
              ease: 'power3.out'
            }
          })

          // ✨ 1. ENTRADA ELEGANTE DE KENIA
          if (keniaText) {
            tl.to(keniaText, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              rotationX: 0,
              filter: 'blur(0px)',
              duration: 1.1,
              ease: 'back.out(1.4)'
            })
          }

          // ✨ 1.5. ENTRADA DE MONJE CON SUTIL RETRASO Y REBOTE FINO
          if (monjeText) {
            tl.to(monjeText, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              filter: 'blur(0px)',
              duration: 1.1,
              ease: 'back.out(1.6)'
            }, '-=0.7')
          }

          // ✨ 2. FOTO CON ZOOM Y REVELADO ELEGANTE
          tl.fromTo(
            foto,
            {
              scale: 0.92,
              filter: 'blur(10px)'
            },
            {
              autoAlpha: 1,
              scale: 1,
              filter: 'blur(0px)',
              duration: 1,
              ease: 'power2.out'
            },
            '-=0.6'
          )

          // ✨ 3. FLORES
          tl.to(
            flores,
            {
              autoAlpha: 1,
              scale: 1,
              filter: 'brightness(1)',
              duration: 0.7,
              stagger: 0.08,
              ease: "back.out(1.2)"
            },
            '-=0.6'
          )

          // ✨ 4. RAMAS
          tl.to(
            ramas,
            {
              autoAlpha: 1,
              scale: 1,
              duration: 0.7,
              stagger: 0.07,
              ease: "power1.inOut"
            },
            '-=0.5'
          )

          // ✨ 5. TEXTO
          tl.to(
            texto,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.08
            },
            '-=0.3'
          )

          // ✨ 6. 15 AÑOS
          tl.to(
            quince,
            {
              autoAlpha: 1,
              letterSpacing: '4px',
              scale: 1,
              filter: 'blur(0px)',
              duration: 1.3,
              ease: 'expo.out'
            },
            '-=0.1'
          )

          // ✨ 7. VERSÍCULO
          tl.to(
            versiculo,
            {
              autoAlpha: 1,
              y: 0,
              filter: 'blur(0px)',
              duration: 1,
              ease: 'power3.out'
            },
            '-=0.5'
          )

          io.disconnect()
        })
      }, {
        threshold: 0.35
      })

      if (rootRef.value) {
        io.observe(rootRef.value)
      }
    })

    return {
      rootRef
    }
  }
}
</script>

<style scoped>
/* Estilos base de los contenedores de flores */
.flor-group {
  position: absolute;
  z-index: 3;
  will-change: transform, opacity;
}

.flor-img {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
  z-index: 4;
}

/* Estilo de la rama naciendo */
.rama-img {
  position: absolute;
  top: 5%;
  left: -50%;
  width: 200%;
  height: 200px;
  z-index: 3;
  opacity: 1;
  pointer-events: none;
}

.versiculo-container {
  margin-top: 20px;
}

.versiculo-texto {
  font-family: "Playfair Display", serif;
  font-size: 18px;
  line-height: 1.9;
  color: #4a4747;
  text-align: center;
  font-style: italic;
}

.versiculo-referencia {
  font-family: "Playfair Display", serif;
  font-size: 14px;
  color: #9c7a32;
  text-align: right;
  margin-top: 10px;
  padding-right: 10px;
  letter-spacing: 1px;
}

/* TÍTULO Y NOMBRES PRINCIPALES */
.nombre-protagonista1 {
  font-family: "CynthiaJuneJF", cursive;
  font-size: 79px;
  margin: 0;
  line-height: 1.4;
  text-align: center;
}

.nombre-kenia {
  display: inline-block;
  background: linear-gradient(
    110deg,
    #375557 30%,
    #3f88bf 45%,
    #8fa8bc 50%,
    #a9b4da 55%,
    #7fafe0 70%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5));
  -webkit-font-smoothing: antialiased;
}

.apellido-playfair {
  display: inline-block;
  font-family: "CynthiaJuneJF", cursive;
  font-size: 79px;
  margin-top: -35px; /* 🔥 Junta Monje hacia arriba */
  line-height: 1.4;
  letter-spacing: 2px;
padding-right:10px ;
  background: linear-gradient(
    110deg,
    #375557 30%,
    #3f88bf 45%,
    #8fa8bc 50%,
    #a9b4da 55%,
    #7fafe0 70%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5));
  -webkit-font-smoothing: antialiased;
}

@keyframes reflejoCromado {
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
}

.ampersand {
  width: 32px;
  height: auto;
  display: block;
  padding-bottom: 20px;
  margin: 0 auto;
  position: relative;
  z-index: 5;
  opacity: 0;
  filter: drop-shadow(0 2px 8px rgba(212, 175, 55, .35)) drop-shadow(0 0 14px rgba(255, 215, 120, .18));
}

/* Posiciones exactas originales */
.flor-1 {
  top: 245px !important;
  left: -5px;
  width: min(34vw, 140px) !important;
  z-index: 0;
}

.flor-2 {
  top: 250px !important;
  right: -10px;
  width: min(40vw, 140px);
}

.flor-3 {
  bottom: -190px;
  left: -30px;
  width: min(44vw, 140px) !important;
  transform: rotate(-0deg);
  z-index: 10;
}

.flor-4 {
  top: 297px !important;
  left: 5px;
  width: min(40vw, 140px);
  transform: translateX(-50%) rotate(0deg);
  z-index: 0;
}

.flor-5 {
  bottom: 40px;
  right: 0px;
  width: min(46vw, 140px);
  transform: translateX(-50%);
  z-index: 8;
  opacity: 0 !important;
}

.flor-6 {
  top: 480px;
  right: -140px;
  width: min(40vw, 140px);
  transform: translateX(-50%);
  z-index: 2;
}

.padrinos-label {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color: #2f2e2e;
  margin-top: 12px;
}

.padrino-nombre {
  font-family: "titulos", cursive;
  font-size: 40px;
  color: #e6b1c4;
  margin: 4px 0;
}

.portada-xv {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 48px 16px 56px;
  margin-top: -30px;
}

.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: -16px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.texto-xv {
  max-width: 620px;
  text-align: center;
  margin-top: 22px;
  padding: 0 8px;
}

.frase-bendicion {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color: #2f2e2e;
  line-height: 1.5;
  margin: 20px 0 10px;
}

.separador-elegante {
  width: 110px;
  height: 2px;
  margin: 12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}

.nombre-protagonista2 {
  font-family: 'Playfair Display', serif;
  font-size: 54px !important;
  font-weight: 600;
  margin: 0 0 9px 0;
  line-height: 1.6;
  letter-spacing: 2px;

  background: linear-gradient(
    110deg,
    #4a617a 0%,
    #7a93ac 20%,
    #dbe5ed 40%,
    #ffffff 50%,
    #dbe5ed 60%,
    #627a93 80%,
    #4a617a 100%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  -webkit-text-stroke: 0.3px #4a617a;
  -webkit-font-smoothing: antialiased;

  animation: reflejoCromado 5s linear infinite;
}

.nombre-protagonista {
  font-family: "CynthiaJuneJF", cursive;
  font-size: 54px;
  margin: 0 0 9px 0;
  line-height: 1.6;
  letter-spacing: 2px;

  background: linear-gradient(
    110deg,
    #375557 30%,
    #3f88bf 45%,
    #8fa8bc 50%,
    #a9b4da 55%,
    #7fafe0 70%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5));
  -webkit-font-smoothing: antialiased;
}

.parrafo-presentacion {
  font-family: "quote", sans-serif;
  font-size: clamp(16px, 2.6vw, 16px);
  color: #3d3c3c;
  line-height: 1.7;
  margin-top: 6px;
}

.bola {
  position: absolute;
  width: 220px;
  animation: girar 10s linear infinite;
  opacity: .85;
  z-index: 1;
  opacity: 0 !important;
  will-change: transform;
}

.bola-izquierda {
  left: -20px;
  bottom: -50px;
  z-index: 9;
}

@keyframes girar {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (min-width: 992px) {
  .portada-xv {
    padding-top: 14px;
  }
  .imagen-xv-wrapper {
    margin-top: 0;
  }
}

.inicial-g {
  font-family: 'Great Vibes', cursive;
  font-size: 1.8em;
  line-height: 1;
  color: #7d95ab;
  font-weight: 400 !important;
}

.nombre-normal {
  font-family: "CynthiaJuneJF", cursive;
  font-size: 59px;
  margin: 0 0 9px 0;
  line-height: 1.9;
  letter-spacing: 2px;

  background: linear-gradient(
    110deg,
    #638193 30%,
    #3f88bf 45%,
    #8fa8bc 50%,
    #a9b4da 55%,
    #7fafe0 70%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5));
  -webkit-font-smoothing: antialiased;
}

/* 🔹 INDICADOR DE SCROLL */
.scroll-indicator {
  position: absolute;
  top: 600px;
  right: 25px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 9999;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.92);
  padding: 8px 14px;
  border-radius: 30px;
  backdrop-filter: blur(6px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.6);
  opacity: 1 !important;
  visibility: visible !important;
}

.hand-icon {
  width: 28px;
  height: 28px;
  transform: rotate(180deg);
}

.scroll-text {
  font-family: "Playfair Display", serif;
  font-size: 12px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #2f2e2e;
  font-weight: 700;
}
</style>